import gnb from './gnb'
import orgmap from './orgmap'
import totalSearch from './totalSearch'
import common from './common'
import mail from './mail'

export default {
    gnb,
    orgmap,
    totalSearch,
    common,
    mail
}